import {Routes} from '@angular/router';
import {authGuard} from './guards/auth.guard';
import {ShellComponent} from './shared/shell/shell.component';

export const routes: Routes = [
  {
    path: 'login',
    children: [
      {
        path: 'callback',
        loadComponent: () => import('./pages/auth/auth-callback/auth-callback.component').then(m => m.AuthCallbackComponent),
      },
    ],
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
      {
        path: 'dashboard',
        title: 'Dashboard',
        data: {description: 'Overview of your reports and key metrics.'},
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'clients',
        title: 'Clients',
        data: {description: 'Manage and view all client accounts.'},
        loadComponent: () => import('./pages/clients/clients.component').then(m => m.ClientsComponent),
      },
    ],
  },
];
